var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('Quiz',{attrs:{"isPreview":true,"onStart":_vm.handleOnStart,"onSubmit":_vm.handleOnSubmit,"onResult":_vm.handleOnResult}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }